import * as React from "react";
import classnames from "classnames";
import { Card } from "@grandvisionhq/common";
import { FormContext } from "../../Form/Form/Form.js";
/* empty css              */
const FormCard = ({
  selected,
  children,
  className,
  layout,
  respondToFormFields
}) => {
  const context = React.useContext(FormContext);
  const hasInvalidFields = React.useMemo(
    () => respondToFormFields.some(
      (fieldName) => context.getInitialState?.(fieldName) ? !context.getInitialState?.(fieldName)?.isValid && context.getInitialState?.(fieldName)?.isTouched : false
    ),
    [respondToFormFields, context]
  );
  return /* @__PURE__ */ React.createElement(
    Card,
    {
      layout,
      className: classnames("form-card", className, {
        "form-card--selected": selected,
        "form-card--invalid": hasInvalidFields
      })
    },
    children
  );
};
export {
  FormCard as default
};
//# sourceMappingURL=FormCard.js.map
